import {useContext, useState} from "react";
import {ISlot} from "shared/Practices/Entities/ISlot";
import {Dayjs} from "dayjs";
import dayjs from "dayjs";
import ISlotService from "../services/ISlotService";
import {container} from "tsyringe";
import IBooking from "shared/Practices/Entities/IBooking";
import { FatalErrorContext } from "../contexts/FatalErrorContext";
import { IPractice } from "shared/Practices/Entities/IPractice";

const useAvailableSlots = ({practitioner,appointmentType}: IBooking, {yearSlotLimit}: IPractice) => {

  const slotService = container.resolve<ISlotService>('ISlotService');

  const initialSlots: ISlot[] = [];

  let [startDateOfMonth, setStartDateOfMonth] = useState(dayjs().date(1));
  let [slots, setSlots] = useState(initialSlots);
  let [slotsLoading, setSlotsLoading] = useState(false);

  const { fatalErrorSet } = useContext(FatalErrorContext);
  
  const setMonthBeginning = async (firstDateOfMonth: Dayjs) => {
    setSlotsLoading(true);

    return await slotService.getAvailableSlotsForDate(firstDateOfMonth,appointmentType,practitioner).then( function (slots) {   
      if (slots.length > 0) {
            const sortedSlots = slots.sort((a, b) =>
              dayjs(a.slotDate).isAfter(dayjs(b.slotDate)) ? 1 : -1
            );

            firstDateOfMonth = dayjs(sortedSlots[0]?.slotDate);
          }

          setSlots(slots);
          setSlotsLoading(false);
          setStartDateOfMonth(firstDateOfMonth);

          return firstDateOfMonth;
    }).catch(function (error) {
      fatalErrorSet({
        statusCode: error?.response?.status || 500,
        message: error?.response.data?.message || "",
      });
    })

  };

  const getFirstMonthForType = async () => {
    setSlotsLoading(true);
    const maxMonth = yearSlotLimit ? "12" : "6";

    return await slotService.getFirstMonthForType(maxMonth,appointmentType,practitioner).then(function (result) {
        let firstDateOfMonth = dayjs().date(1);

        if (result.firstMonth) {
            const currentMonth = dayjs().date(1);
            firstDateOfMonth = dayjs().month(result.firstMonth - 1).date(1);

            // If month returned is less than the current month it must be next year
            if (firstDateOfMonth.isBefore(currentMonth)) {
                firstDateOfMonth = firstDateOfMonth.add(1, "year");
            }
        }
        return firstDateOfMonth;
    }).catch(function (error) {
      fatalErrorSet({
        statusCode: error?.response?.status || 500,
        message: error?.response.data?.message || "",
      });
    });
  }

  return {slots, slotsLoading, startDateOfMonth, setMonthBeginning, getFirstMonthForType}
};

export default useAvailableSlots;